// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3o5KH","vLegacy":"SelectSecondary_vLegacy__2BNth","error":"SelectSecondary_error__1-Mpt","disabled":"SelectSecondary_disabled__12PWc"};